import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import { Button } from 'react-bootstrap'
import { Text, Label } from '@leverege/ui-elements'

import { BreadcrumbActions, Constants, MessageRouteActions } from '~/actions'

import { List, Screen, YesNoDialog, TextInput, LabelGroup, Loading } from '~/views'
import MessageRouteItem from './MessageRouteItem'
import PaginationSearch from '../utils/PaginationSearch'

import style from './style.css'

class MessageRoutesScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }
  
  constructor( props, context ) {
    super( props, context );
    this.onEvent = this.onEvent.bind( this )
    this.pager = new PaginationSearch( this, 'messageRoutes', ( props, opts ) => {
      this.props.dispatch( MessageRouteActions.list( this.props.match.params.projectId, opts ) )
    } )

    this.state = { 
      selectId : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props ) 
    }
  }

  onEvent( event, item ) {

    if ( event === 'select' ) {
      this.props.history.push( `/project/${this.props.match.params.projectId}/messageRoute/${item.id}` )
    } else if ( event === MessageRouteItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeMessageRoute : item } )
    }
  }

  onPromptRemoveYes = () => {
    const { removeMessageRoute } = this.state
    const { params } = this.props.match
    this.props.dispatch( MessageRouteActions.delete( params.projectId, removeMessageRoute ) );
    this.setState( { showRemoveDialog : false, removeMessageRoute : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeMessageRoute : null } )
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Message Routes' } ] ) )
  }

  componentWillReceiveProps( next ) {
    this.pager.loadIfNeeded( next )
  }

  onCreateMessageRoute( ) {
    const { params } = this.props.match
    if ( params && params.projectId ) {
      this.props.dispatch( MessageRouteActions.create( params.projectId, { name : 'My Message Route', routes : {} } ) );
    }
  }

  render() {
    const { messageRoutes, projects } = this.props
    const { params } = this.props.match
    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()
    const projectId = params && params.projectId

    const loading = messageRoutes.status == Constants.STATUS_LOADING
    const items = messageRoutes.projectId == projectId ? this.pager.getPageItems() : []

    const { selectId, removeMessageRoute, transferItem, showTransfer, search, start } = this.state

    const isSelected = function( item ) { return item && item.id == selectId; }

    const left = ( 
      <div className={style.left}>
        <List className={style.list}
          onEvent={this.onEvent} 
          isSelected={isSelected}
          noItemsView={loading ? null : <div />}
          items={items}
          itemView={MessageRouteItem}
          itemProps={{ hideNavButtons : true }} />

        <div className={style.pagination}>
          <Pagination
            innerClass={classnames( 'pagination', style.innerPagination )}
            activePage={page}
            itemsCountPerPage={perPage}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            onChange={this.pager.onPageChange} />
        </div>
        <Loading show={loading} message="Loading..." />
      </div>
    )

    const details = null
    let right

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Message Routes</Text>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <Label><i className="fa fa-search" /></Label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => { this.onCreateMessageRoute() }}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Message Route
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {left}
        </Screen.Content>

        <YesNoDialog show={this.state.showRemoveDialog} 
          title={`Remove ${removeMessageRoute && removeMessageRoute.name}?`}
          message={<div>Are you sure you want to delete the message route?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    messageRoutes : state.messageRoutes,
    projects : state.projects
  } )
)( MessageRoutesScreen );
